module.exports = __webpack_public_path__ + "img/liveEventEnabled.ffb09e.svg";